<template>
    <div>
        <div style="padding:10px 0 10px 10px;background: #f7f7f7;">
            {{$t('mis.nps.barChartLabel')}}:<span style="font-weight: bold;font-size: 25px;color: red;">{{ this.npsValue }}</span>
        </div>
        <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
            <FORM ref="npsForm"  @formclick="formclick" :formData="npsFormData"></FORM>
            <div id="nps-histogram" style="height: 600px;width: 80%;float:left"></div>
        </div>
        <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
            <div style="width: 50%;float:left">
                <FORM ref="positiveForm"  @formclick="formclick" :formData="positiveFormData"></FORM>          
                <div id="nps-positive" style="height: 600px;width: 100%;float:left;border-right: 1px solid #999"></div>
            </div>
            <div style="width: 50%;float:left">
                <FORM ref="negativeForm"  @formclick="formclick" :formData="negativeFormData"></FORM>
                <div id="nps-negative" style="height: 600px;width: 100%;float:left;border-right: 1px solid #999"></div>
            </div> 
        </div>
    </div>
</template>
  
<script>
    //table封装组件
    import URL from '@/views/mis/util/url'
    import FORM from '../../components/page/form.vue'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    const Echarts = require('echarts');

    let npsTypesMap = {
        // 1: window.$t("mis.nps.pirChartLegend1"),
        // 2: window.$t("mis.nps.pirChartLegend2"),
        // 3: window.$t("mis.nps.pirChartLegend3"),
        // 4: window.$t("mis.nps.pirChartLegend4"),
        // 5: window.$t("mis.nps.pirChartLegend5"),
        // 6: window.$t("mis.nps.pirChartLegend6"),
        // 7: window.$t("mis.nps.pirChartLegend7"),
        // 8: window.$t("mis.nps.pirChartLegend8"),
        // 9: window.$t("mis.nps.pirChartLegend9"),
        // 99: window.$t("mis.nps.pirChartLegend10"),
    };
    
    let npsTypes = [
        // window.$t("mis.nps.pirChartLegend1"),
        // window.$t("mis.nps.pirChartLegend2"),
        // window.$t("mis.nps.pirChartLegend3"),
        // window.$t("mis.nps.pirChartLegend4"),
        // window.$t("mis.nps.pirChartLegend5"),
        // window.$t("mis.nps.pirChartLegend6"),
        // window.$t("mis.nps.pirChartLegend7"),
        // window.$t("mis.nps.pirChartLegend8"),
        // window.$t("mis.nps.pirChartLegend9"),
        // window.$t("mis.nps.pirChartLegend10"),
    ];

    export default {
        name: 'chart',
        components: {
            FORM
        },
        created() {
            // Get metadata for the chart
            this.$axios.get(URL.nps.type).then(res => {
                    if (res.code == 0 && res.result.length > 0) {
                        let typeList = res.result;
                        let locale = this.$i18n.locale;
                        console.log("locale: ", locale);
                        npsTypesMap = {};
                        npsTypes = [];
                        switch (locale) {
                            case "zh_CN":
                                typeList.forEach(element => {
                                    npsTypesMap[element.type] = element.descriptionCn;
                                });
                                npsTypes = typeList.map(element => element.descriptionCn);
                                break;
                            case "en_US":
                                typeList.forEach(element => {
                                    npsTypesMap[element.type] = element.descriptionEn;
                                });
                                npsTypes = typeList.map(element => element.descriptionEn);
                                break;
                            case "vi_VN":
                                typeList.forEach(element => {
                                    npsTypesMap[element.type] = element.descriptionVn;
                                });
                                npsTypes = typeList.map(element => element.descriptionVn);
                                break;
                        }
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.error(err);
                });
        },
        mounted() {
            this.init();
        },
        methods: {
            init(){
                // Initalize the bar chart
                this.$axios.get(URL.nps.statistic).then(res => {
                    if (res.code == 0 && res.result) {
                        let barRawData = res.result.scoreStatistic;
                        
                        this.calculateNpsValue(barRawData);
                        this.renderBarChart("nps-histogram", this.parseBarChartData(barRawData));  
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.error(err);
                });
                // Initalize the positive pie chart
                this.$axios.get(URL.nps.statistic, { params: { nature: 1 } }).then(res => {
                    if (res.code == 0 && res.result) {
                        let chartRawData = res.result.typeStatistic;
                        this.renderPieChart("nps-positive", this.parsePieChartData(chartRawData)); 
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.error(err);
                });
                // Initalize the negative pie chart
                this.$axios.get(URL.nps.statistic, { params: { nature: -1 } }).then(res => {
                    if (res.code == 0 && res.result) {
                        let chartRawData = res.result.typeStatistic;
                        this.renderPieChart("nps-negative", this.parsePieChartData(chartRawData));
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.error(err);
                });
            },
            formclick (clickName, formData) {
                // console.log("Form Data: ", formData, clickName);

                this.queryData.fromTime = formData.timeRangeStart ? DateUtil.formatDate(formData.timeRangeStart, "yyyy-MM-dd hh:mm:ss") : undefined;
                this.queryData.toTime = formData.timeRangeEnd ? DateUtil.formatDate(formData.timeRangeEnd, "yyyy-MM-dd hh:mm:ss") : undefined;
                this.queryData.nature = formData.nature ? formData.nature : undefined;
                
                // console.log("Query Data: ", this.queryData);
                this.query(clickName);
            },
            query (clickName) {
                this.$axios.get(URL.nps.statistic, { params: this.queryData }).then(res=> {
                    if (res.code == 0 && res.result) {
                        let barRawData = res.result.scoreStatistic;
                        let chartRawData = res.result.typeStatistic;
                        switch (clickName) {
                            case "npsFormClick":
                                this.calculateNpsValue(barRawData);
                                this.renderBarChart("nps-histogram", this.parseBarChartData(barRawData));
                                break;
                            case "positiveFormClick":
                                this.renderPieChart("nps-positive", this.parsePieChartData(chartRawData));
                                break;
                            case "negativeFormClick":
                                this.renderPieChart("nps-negative", this.parsePieChartData(chartRawData));
                                break;
                        }
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.error(err);
                });
            },
            renderBarChart (id, chartData) {
                let options = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    grid: {},
                    xAxis: [{
                        type: "category",
                        data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
                        name: window.$t("mis.nps.barChartXAxisName")
                    }],
                    yAxis: [{
                        type: "value",
                        name: window.$t("mis.nps.barChartYAxisName"),
                        nameTestStyle: {
                            align: "center"
                        }
                    }],
                    series: [{
                        name: window.$t("mis.nps.barChartYAxisName"),
                        type: "bar",
                        data: chartData,
                        itemStyle: {
                            color: (obj) => {
                                if (obj.dataIndex < 6) {
                                    return "rgba(235, 50, 50, 1)";
                                } else if (obj.dataIndex < 8) {
                                    return "rgba(50, 235, 50, 1)";
                                } else {
                                    return "rgba(50, 50, 235, 1)";
                                }
                            }
                        },
                        barWidth: 40
                    }]
                };
                Echarts.init(document.getElementById(id)).setOption(options);
            },
            renderPieChart (id, chartData) { 
                let title = "nps-positive" == id ? window.$t("mis.nps.pieChartPositiveTitle") : window.$t("mis.nps.pieChartNegativeTitle");
                let subTitle = "nps-positive" == id ? window.$t("mis.nps.pieChartPositiveSubTitle") : window.$t("mis.nps.pieChartNegativeSubTitle");
                let options = {
                    title: {
                        text: title,
                        subtext: subTitle,
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: npsTypes
                    },
                    series: [{
                        type: "pie",
                        name: subTitle,
                        data: chartData,
                        startAngle: 90,
                        colorBy: "data"
                    }],
                    emphasis: {
                        itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                };
                Echarts.init(document.getElementById(id)).setOption(options);
            },
            calculateNpsValue (rawData) {
                let negativeScore = 0;
                let positiveScore = 0;
                let filteredData = rawData.filter(item => item.count > 0);
                if (filteredData.length > 0) {
                    let totalCount = filteredData.map(item => item.count).reduce((acc, cur) => acc + cur, 0);
                    let negativeCount = filteredData.filter(item => item.score < 7).map(item => item.count).reduce((acc, cur) => acc + cur, 0)
                    let positiveCount = filteredData.filter(item => item.score > 8).map(item => item.count).reduce((acc, cur) => acc + cur, 0)
                    negativeScore = negativeCount / totalCount * 100;
                    positiveScore = positiveCount / totalCount * 100;
                }
                this.npsValue = Number((positiveScore - negativeScore).toFixed(2));
            },
            parseBarChartData (rawData) {
                let data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                if (rawData.length > 0) {
                    for (let i = 0; i < rawData.length; i++) {
                            data[i] = rawData[i].count;
                    }
                }
                return data;
            },
            parsePieChartData (rawData) {
                let data = [];
                if(rawData.length > 0) {
                    data = rawData.map(item => {
                        return {
                            value: item.count,
                            name: npsTypesMap[item.npsType.type]
                        }
                    });
                }
                return data;
            }
        },
        data () {
            return {
                queryData: {},
                npsValue: NaN,
                npsFormData: {
                    noInitClick: true,
                    // initClickName: "npsFormClick",
                    cols: [
                        { title: "", field: 'timeRange', type: 6},
                        { click: "npsFormClick", buttonLabel: window.$t("mis.nps.refreshChartButton") ,auth: "mis:app:nps:chartQuery"},
                    ]
                },
                positiveFormData: {
                    noInitClick: true,
                    // initClickName: "positiveFormClick",
                    cols: [
                        { title: "", hidden: true, field: 'nature', data: 1},
                        { title: "", field: 'timeRange', type: 6},
                        { click: "positiveFormClick", buttonLabel: window.$t("mis.nps.refreshChartButton") ,auth: "mis:app:nps:chartQuery"},
                    ]
                },
                negativeFormData: {
                    noInitClick: true,
                    // initClickName: "negativeFormClick",
                    cols: [
                        { title: "", hidden: true, field: 'nature', data: -1},
                        { title: "", field: 'timeRange', type: 6},
                        { click: "negativeFormClick", buttonLabel: window.$t("mis.nps.refreshChartButton") ,auth: "mis:app:nps:chartQuery"},
                    ]
                }
            }
        }
    }
  </script>
  